module.exports = __webpack_public_path__ + "static/media/icon_cart_empty.8c456531.svg";